/* eslint-disable max-lines-per-function */
import { useDeleteTerminKalender } from '@/domain/termine/hooks/useDeleteTerminKalender';
import { TerminKalender } from '@/domain/termine/shared/types/TerminKalender';
import { toast } from '@/hooks/use-toast';
import { useTranslation } from 'react-i18next';

export function useKalenderDeleteHandler(kalenderList?: TerminKalender[]) {
  const { t } = useTranslation();
  const { deleteTerminKalender, loading } = useDeleteTerminKalender();

  const handleDelete = async (
    kalender: TerminKalender,
    idTargetTerminkalender?: string,
  ) => {
    function mapNoKalenderToNull(id: string) {
      return id === 'NO_KALENDER' ? null : id;
    }

    try {
      await deleteTerminKalender({
        deleteKalenderInput: {
          idTerminkalender: kalender.id,
          idTargetTerminkalender: mapNoKalenderToNull(idTargetTerminkalender),
        },
      });

      if (idTargetTerminkalender) {
        const targetKalender = kalenderList?.find(
          (k) => k.id === idTargetTerminkalender,
        );
        toast({
          title: t('domain.termine.kalender.deleteDialog.success', {
            name: kalender.name,
          }),
          description: t(
            'domain.termine.kalender.deleteDialog.targetKalender',
            {
              name: targetKalender?.name ?? '',
            },
          ),
        });
      } else {
        toast({
          title: t('domain.termine.kalender.deleteDialog.success', {
            name: kalender.name,
          }),
        });
      }
      return true;
    } catch (error) {
      toast({
        title: t('domain.termine.kalender.deleteDialog.error'),
        description: error instanceof Error ? error.message : undefined,
        variant: 'destructive',
      });
      return false;
    }
  };

  return { handleDelete, loading };
}
